(function () {
  if (!window.B2B?.enabled) return;

  const REQUIRED_TAG = 'espresso_bar_iasi';

  const TARGET_CATEGORIES = [
    "Single Origin",
    "Rarities",
    "Competition"
  ];

  const MIN_KG = 100;
  const DISCOUNT_PERCENT = 15;

  // ==========================
  // CHECK TAG
  // ==========================
  function isEligibleCustomer() {
    const tags = window.B2B.customerTags || [];
    return tags.includes(REQUIRED_TAG);
  }

  // ==========================
  // CALCUL DATA
  // ==========================
  function calculate(cart) {
    const categoryData = {};

    cart.items.forEach(item => {
      const category = item.product_type;

      if (!TARGET_CATEGORIES.includes(category)) return;

      const kg = (item.grams * item.quantity) / 1000;
      const subtotal = item.final_line_price / 100;

      if (!categoryData[category]) {
        categoryData[category] = { kg: 0, subtotal: 0 };
      }

      categoryData[category].kg += kg;
      categoryData[category].subtotal += subtotal;
    });

    return categoryData;
  }

  // ==========================
  // GET ELIGIBLE
  // ==========================
  function getEligible(categoryData) {
    return Object.entries(categoryData).filter(
      ([_, data]) => data.kg >= MIN_KG
    );
  }

  // ==========================
  // UI RENDER
  // ==========================
  function render(categoryData) {
    document.querySelector('.espresso-box')?.remove();
    document.querySelector('.espresso-btn')?.remove();

    const eligible = getEligible(categoryData);

    if (!eligible.length) {
      localStorage.removeItem('espressoClosed');
      return;
    }

    // dacă e închis → doar buton
    if (localStorage.getItem('espressoClosed') === 'true') {
      createButton(categoryData);
      return;
    }

    const box = document.createElement('div');
    box.className = 'espresso-box';

    box.style.cssText = `
      position:fixed;
      bottom:90px;
      left:20px;
      z-index:9999;
      padding:18px;
      background:#64B2B8;
      color:#fff;
      border-radius:14px;
      font-size:14px;
      line-height:1.5;
      box-shadow:0 12px 30px rgba(0,0,0,0.25);
      max-width:260px;
      animation:fadeIn .25s ease;
    `;

    let html = `
      <div style="display:flex; justify-content:space-between; align-items:center;">
        <strong>🎉 15% B2B Discount</strong>
        <span class="espresso-close" style="cursor:pointer;">✕</span>
      </div>
      <div style="font-size:12px;margin:10px 0;">
        la minimum 100 kg / categorie
      </div>
    `;

    eligible.forEach(([category, data]) => {
      const discount = data.subtotal * (DISCOUNT_PERCENT / 100);
      const final = data.subtotal - discount;

      html += `
        <div style="margin-bottom:10px;">
          <strong>${category}</strong><br>
          ${data.kg.toFixed(1)}kg<br>
          Subtotal: ${data.subtotal.toFixed(2)} lei<br>
          Discount: -${discount.toFixed(2)} lei<br>
          <strong>Suma: ${final.toFixed(2)} lei</strong>
        </div>
      `;
    });

    box.innerHTML = html;
    document.body.appendChild(box);

    // close
    box.querySelector('.espresso-close').addEventListener('click', () => {
      box.remove();
      localStorage.setItem('espressoClosed', 'true');
      createButton(categoryData);
    });
  }

  // ==========================
  // MINIMIZED BUTTON
  // ==========================
  function createButton(categoryData) {
    const btn = document.createElement('div');
    btn.className = 'espresso-btn';
    btn.innerHTML = '15% B2B Discount';

    btn.style.cssText = `
      position:fixed;
      bottom:90px;
      left:20px;
      z-index:9998;
      padding:10px 14px;
      background:#64B2B8;
      color:#fff;
      border-radius:12px;
      cursor:pointer;
      font-size:13px;
      box-shadow:0 8px 20px rgba(0,0,0,0.2);
    `;

    btn.addEventListener('click', () => {
      localStorage.removeItem('espressoClosed');
      run();
    });

    document.body.appendChild(btn);
  }

  // ==========================
  // MAIN
  // ==========================
  async function run() {
    if (!isEligibleCustomer()) return;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const categoryData = calculate(cart);
      render(categoryData);

    } catch (err) {
      console.error('B2B Espresso UI error:', err);
    }
  }

  // ==========================
  // LISTENERS
  // ==========================
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('input', run);
  document.addEventListener('click', run);
  document.addEventListener('cart:updated', run);

})();